import { RefObject, useState } from 'react';

type Options = {
  restoreFocusOnToggle?: boolean;
};

export const useToggleInputValueVisible = (
  inputRef: RefObject<HTMLInputElement | null>,
  { restoreFocusOnToggle = true }: Options = {}
) => {
  const [isValueVisible, setIsValueVisible] = useState(false);

  const toggleValueVisibility = () => {
    setIsValueVisible(!isValueVisible);

    if (!restoreFocusOnToggle || !inputRef?.current) return;

    setTimeout(() => {
      const input = inputRef.current;
      if (input && input.ownerDocument && input.ownerDocument.contains(input)) {
        try {
          const { length } = input.value || '';
          input.focus();
          input.setSelectionRange(length, length);
        } catch {
          // Silently ignore Range API errors if element was removed
        }
      }
    }, 0);
  };

  return { isValueVisible, setIsValueVisible, toggleValueVisibility };
};
